<template>
    <div class="d-flex align-left flex-column">
        <div class="mt-10 pa-5 text-center">
            <p class="display-1 font-weight-bold">We’re very sorry that you had a bad experience</p>
        </div>
        <div class="d-flex justify-center flex-wrap">
            <v-textarea
                v-model="comment"
                name="input-7-1"
                filled
                label="Please comment which area of the club facilities that you had a bad experience (min 10 characters)"
                auto-grow
                value=""
                ></v-textarea>
        </div>
        <div class="d-flex justify-center flex-wrap">
            <p class="font-italic">Please provide us your Name, Contact Number or Email address if you want us to respond to your feedback.</p>
        </div>
        <div class="ma-5 text-center">
            <v-btn @click="onBack()" color="primary" large
                ><v-icon>mdi-chevron-left</v-icon> Back</v-btn
            >
            <v-btn @click="onSubmit()" color="primary" class="ml-4" large
                >Submit <v-icon>mdi-chevron-right</v-icon></v-btn
            >
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            comment: null
        };
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        onBack() {
            this.$router.go(-1);
        },
        onSubmit() {
            if (this.comment == null || this.comment.length < 10) {
                alert("Please enter a comment with at least 10 characters")
            } else {
                this.$store.commit('feedback/setComment', this.comment)
                this.$router.push("/thank-you");
            }
        }
    }
};
</script>
<style>
.location {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40vh;
    justify-items: center;
}
.routerLink {
    text-decoration: none;
}
.temasek-imgbtn-locat {
    width: 210px;
    margin: 16px;
}
</style>
